import { BodyText, Button, Flex } from '@utilitywarehouse/hearth-react';
import {
  ChevronRightSmallIcon,
  WarningMediumIcon,
} from '@utilitywarehouse/hearth-react-icons';
import { FC } from 'react';

type NoProvidersFoundProps = {
  isLoading: boolean;
  onContinue: () => void;
  onRetry: () => void;
};

const NoProvidersFound: FC<NoProvidersFoundProps> = ({
  isLoading,
  onContinue,
  onRetry,
}) => {
  return (
    <Flex
      data-testid="no-providers-found"
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap="100"
      padding="200"
    >
      <Flex direction="column" alignItems="center" gap="100">
        <Flex alignItems="center" gap="100">
          <WarningMediumIcon />
          <BodyText weight="semibold">
            Couldn&apos;t load your providers right now.
          </BodyText>
        </Flex>
        <BodyText color="secondary" style={{ textAlign: 'center' }}>
          Try refreshing, or continue and contact your provider to cancel your
          existing service.
        </BodyText>
      </Flex>
      <Flex alignItems="center" gap="300" marginTop="100">
        <Button
          type="button"
          variant="ghost"
          onClick={onRetry}
          disabled={isLoading}
          data-testid="no-provider-try-again-button"
          style={{ backgroundColor: 'white' }}
          size="sm"
          colorScheme="functional"
        >
          Refresh
        </Button>

        <Button
          type="button"
          variant="outline"
          onClick={onContinue}
          disabled={isLoading}
          data-testid="no-providers-continue-button"
          style={{ backgroundColor: 'white' }}
          colorScheme="functional"
        >
          Continue
          <ChevronRightSmallIcon />
        </Button>
      </Flex>
    </Flex>
  );
};

export default NoProvidersFound;
